export default {
  services: "Servicios",
  howToOperate: "Cómo Operar",
  regulations: "Regulaciones",
  commissary: "Comisaría",
  about: "Nosotros",
  contact: "Contacto",
  bookSession: "Reservar una Sesión",
};